export const filter = {
    id: "",
    time: "",
    search: "",
    created_at: "",
    updated_at: "",
};
